<template>
 <div id="page-content">
    <div class="container">
      <div class="row">		
        <div class="col-md-12">
          <div v-if="loading" class="page-loader-inline">
            <div class="loading-spinner-wrap">
              <div class="loading-spinner"></div>
              <div class="loading-spinner-inner"></div>
            </div>
            <p>載入中...</p>
          </div>
          <school-list-view
            v-if="!loading"
            :loading="loading"
            :pagedItems="pagedItems"
            :level="level"
            :total="total"
            :currentPage="currentPage"
            :perPage="perPage"
            :model="model"
            @sortFromView="sortBy"
            @pageChange="setPage"
            @showDetails="storeStatus('schools')"
            @filterOnChange="handleFilterChange">
          </school-list-view>
        </div>
        <div class="col-md-3 col-md-pull-9 category-toggle" ref="list-top"></div>
      </div> <!-- end .row -->
    </div> <!-- end .container -->
  </div>	
</template>




<script>
import "bootstrap-vue/dist/bootstrap-vue.css";
import pagination from "vue-bootstrap-pagination";
import * as mixin from "../secret/CryptoMaxin.vue";
import * as detectMobileMixin from "../shared/detect-mobile-mixin.vue";
import * as detectIEMixin from "../shared/detect-ie-mixin.vue";
import * as CryptoJS from "crypto-js";
import leftSideBar from "./SenLeftSideBar.vue";
import SenSchoolListView from "./SenSchoolListView.vue";


export default {
  mixins: [mixin,  detectMobileMixin, detectIEMixin],
  components: {
    pagination,
      "left-side-bar":leftSideBar,
      "school-list-view": SenSchoolListView,
  },
  props: {
    district: "",
    serveType: "",
    keyword: "",
    initItems: ""
  },

  watch: {
    finishInit: "loadedKey",
    sortedBy:{
      handler: function(n, o) {      
          // console.log("sortedBy, value", n);
      }
    },     
    display: {
      handler: function(newVal, oldVal) {
        // sessionStorage.setItem("sen-display", this.display);
        // console.log("current page", this.currentPage);
        // this.setPage(this.currentPage);
      }
    }
  },
  data() {
    return {
      mobile: false,
      showSideMenu: true,
      display: "LIST",
      level: "特殊學校",
      pagedItems: [],
      schools: [],
      schoolIndexLink: "",
      filteredItems: [],
      loading: false,
      districts: [],
      religious: [],
      serveTypes: [],
      genders: [],
      cachedPage: 1,
      isRestoreCache: false,
      filterMsg: "",
      model: {
        districts: [],
        religious: [],
        serveTypes: [],
        genders: [],
        keyword: ""
      },
      sortedBy:null,
      sortSeq: {
        服務類別: "asc",
        宗教: "asc",
        性別: "asc"
      },
      perPage: 10,
      total: 0,
      currentPage: 1
    };
  },
  mounted() {
     this.$nextTick(() => {
        window.addEventListener('resize', () => {
            this.checkIsMobile();
        });
    })
    this.checkIsMobile();    
    this.alertIE();
    this.loading = true;
    // this.getMessage("SCHOOL", "SEN", "LIST");
    // console.log("notify", this.$notify);
  },
  methods: {
    checkIsMobile(){
        this.mobile = this.isMobile();              
        this.showSideMenu = !this.mobile; 
        // console.log("run check is mobile", this.showSideMenu);     
    },    
    loadedKey() {
      //sessionStorage.removeItem("sen-display");
      //sessionStorage.removeItem("sen");
      let self = this;
      let sd = sessionStorage.getItem("sen-display");
      if (sd != null) this.display = sd;
      let cacheItems = sessionStorage.getItem("sen");
      // console.log("loaded key cacheItems", cacheItems);
      if (cacheItems) {
        this.decrypt_data(
          new Uint16Array(self.base64ToArrayBuffer(cacheItems))
        ).then(
          function(result) {
            let decryptedData = self.convertArrayBufferViewtoString(
              new Uint16Array(result)
            );
            let tmp = JSON.parse(decryptedData);
            self.isRestoreCache = true;
            if (tmp) {
              self.schools = tmp.schools;
              self.genders = tmp.genders;
              self.religious = tmp.religious;
              self.serveTypes = tmp.serveTypes;
              self.districts = tmp.districts;
              self.cachedPage = tmp.current_page;
              self.init();
            } else {
              self.fetchData();
            }
          },
          function(e) {
            console.log("error message", e);
            self.fetchData();
          }
        );
      } else {
        self.fetchData();
      }
    },
    fetchData() {
      this.isRestoreCache = false;
      axios.get(`${apiEndPoint}/list`).then(res => {
        // console.log(this.schools);
        let decrypted = JSON.parse(
          CryptoJS.AES.decrypt(JSON.stringify(res.data), this.getPass(), {
            format: CryptoJSAesJson
          }).toString(CryptoJS.enc.Utf8)
        );
        this.schools = decrypted.list;
        this.religious = decrypted.metadata.宗教;
        this.serveTypes = decrypted.metadata.服務類別;
        this.genders = decrypted.metadata.就讀學生性別;
        this.districts = decrypted.metadata.分區;
        this.init();
      });
    },
    storeStatus(target) {
      let self = this;
      // if(target == 'filter'){
      let data = { level: this.level, filters: this.model };
      //sessionStorage.setItem("sen-filter", JSON.stringify(data));
      // }

      if (target == "schools") {
        let data = {
          school_level: this.level,
          current_page: this.currentPage,
          religious: this.religious,
          serveTypes: this.serveTypes,
          genders: this.genders,
          districts: this.districts,
          schools: this.schools,
          create_datetime: moment()
        };
        data = JSON.stringify(data);
        this.encrypt_data(data).then(
          function(result) {
            // console.log("result plain text", result );
            let encryptedData = new Uint16Array(result);
            //  self.decrypt_data(encryptedData);
            var base64Data = self.arrayBufferToBase64(result);
            //sessionStorage.setItem("sen", base64Data);
          },
          function(e) {
            console.log(e.message);
          }
        );
      }
    },
    refresh() {
        this.loading = true;
        this.fetchData();
    },
    reset() {
        sessionStorage.removeItem("sen-filter");
        this.prepareFilters();
        this.model.keyword = "";
        this.filter();
        this.storeStatus("filter");
        this.goTop();
    },
    prepareFilters() {
      this.serveTypes.forEach(f => {
        this.model.serveTypes[f] = false;
      });
      this.model.serveTypes = Object.assign({}, this.model.serveTypes);

      this.religious.forEach(r => {
        this.model.religious[r] = false;
      });
      this.model.religious = Object.assign({}, this.model.religious);
      this.genders.forEach(g => {
        this.model.genders[g] = false;
      });
      this.model.genders = Object.assign({}, this.model.genders);

      this.districts.forEach(d => {
        this.model.districts[d] = false;
      });
      this.model.districts = Object.assign({}, this.model.districts);

      // search criteria was entered as prop,init the search filter
      if (this.keyword) {
        this.model.keyword = this.keyword;
      }
      if (this.serveType) {
          Vue.set(this.model.serveTypes, this.serveType, true);
      }

      if (this.district) {
          Vue.set(this.model.districts, this.district, true);
      }
      this.filter();
    },
    init() {
      // console.log("init serveType",this.serveType);
      // if (this.isMobile()) document.getElementById("filter").scrollIntoView();
      this.filteredItems = this.schools;
      this.filteredItems = _.orderBy(
        this.filteredItems,
        ["sortadv", "isReg"],
        ["asc", "asc", "desc"]
      );

      let sFilter = sessionStorage.getItem("sen-filter");
      if (sFilter != null && this.isRestoreCache && this.serveType=='') {        
        sFilter = JSON.parse(sFilter);
        this.model = sFilter.filters;
        this.filter();
        this.setPage(this.cachedPage, false);
        this.currentPage = this.cachedPage;
      } else {
        this.prepareFilters();
        this.filter();
        this.currentPage = 1;
        this.setPage(1, false);
      }
    },
    sortBy(column, direction) {
      let temp = _.orderBy(this.filteredItems, column, direction);
      this.filteredItems = temp;
      this.setPage(1);
    },
    handleFilterChange(model) {
      this.model = model;
      this.filter();
    },
    orderBy(col) {
      let sortSeq = this.sortSeq[col] == "asc" ? "desc" : "asc";

      this.sortSeq[col] = sortSeq;
      // console.log(this.sortSeq[col]);
      let temp = _.orderBy(this.filteredItems, col, this.sortSeq[col]);
      this.filteredItems = temp;

      this.currentPage = 1;
      this.setPage(1);
    },
    filter() {
      this.filterMsg = "";
      let temp = this.schools;

      if (this.model.keyword) {
        if (this.filterMsg.indexOf(this.model.keyword) == -1) {
          this.filterMsg += ` ${this.model.keyword} `;
        }

        let keyword = this.model.keyword;

        if (/^\d+$/.test(keyword)) {
          temp = temp.filter(s => {
            return String(s.電話 || '').includes(keyword);
          });
        } else {
          var options = {
            shouldSort: true,
            findAllMatches: false,
            threshold: 0.3,
            location: 0,
            distance: 100,
            maxPatternLength: 100,
            minMatchCharLength: 1,
            keys: ["中文名稱", "english_name", "分區", "中文地址", "服務類別", "學生性別"]
          };
          var fuse = new Fuse(temp, options);
          temp = fuse.search(keyword);
        }
        this.$delete(this.keyword);
      }

      if (this.isModified("religious")) {
        temp = temp.filter(s => {
          if (this.model.religious[s.宗教]) return true;
        });
        for (let idx in this.model.religious) {
          if (this.model.religious[idx] && this.filterMsg.indexOf(idx) == -1)
            this.filterMsg += ` ${idx} `;
        }
      }

      if (this.isModified("serveTypes")) {
        temp = temp.filter(s => {
          if (this.model.serveTypes[s.服務類別]) return true;
        });
        for (let idx in this.model.serveTypes) {
          if (this.model.serveTypes[idx] && this.filterMsg.indexOf(idx) == -1)
            this.filterMsg += ` ${idx} `;
        }
        this.$delete(this.serveType);
      }

      if (this.isModified("genders")) {
        temp = temp.filter(s => {
          if (this.model.genders[s.就讀學生性別]) return true;
        });
        for (let idx in this.model.genders) {
          if (this.model.genders[idx] && this.filterMsg.indexOf(idx) == -1)
            this.filterMsg += ` ${idx} `;
        }
      }

      if (this.isModified("districts")) {
        temp = temp.filter(s => {
          if (this.model.districts[s.分區]) return true;
        });
        for (let idx in this.model.districts) {
          if (this.model.districts[idx] && this.filterMsg.indexOf(idx) == -1)
            this.filterMsg += ` ${idx} `;
        }
        this.$delete(this.district);
      }
      // console.log(temp)
      temp = _.orderBy(
        temp,
        ["sort_adv", "isReg"],
        ["asc", "asc", "desc"]
      );

      this.filteredItems = temp;

      this.storeStatus("filter");

      this.currentPage = 1;
      this.setPage(1, false);
    },
    isModified(col) {
      let modified = false;
      Object.keys(this.model[col]).forEach(prop => {
        if (this.model[col][prop]) modified = true;
      });
      return modified;
    },
    goTop(scroll = true){
        if (!scroll) return;
        const header = document.querySelector('.school-list-header');
        if (header) {
            const top = header.offsetTop - 80;
            window.scrollTo({ top: top, behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    },
    setPage(page, scroll = true) {
      this.loading = false;
    
      this.goTop(scroll);

      // if (this.isMobile()) {
      //   document.getElementById("filter").scrollIntoView();
      // } else {
      //   document.getElementById("breadcrumb").scrollIntoView();
      // }

      if (!page) {
        page = this.currentPage;
      }
      // console.log("run loadData =%, page= ", this.currentPage, page);
      if (page < 1) {
        return;
      } else if (this.total > 0 && page > this.total) {
        return;
      }
      let pagination = this.getPager(
        this.filteredItems.length,
        page,
        this.perPage
      );

      this.total = pagination.total;
      this.currentPage = pagination.current_page;

      this.pagedItems = this.filteredItems.slice(
        pagination.from,
        pagination.to
      );
    },
    getPager(totalItems, currentPage = 1, pageSize = 10) {
      let totalPages = Math.ceil(totalItems / pageSize);

      let from = 0,
        to = 0;

      from = currentPage * pageSize - pageSize;
      let remaining = totalItems % pageSize;

      if (currentPage == totalPages) {
        remaining > 0 ? (to = from + remaining) : (to = currentPage * pageSize);
      } else {
        to = currentPage * pageSize;
      }

      let pages = _.range(1, totalPages + 1);
      return {
        total: totalItems,
        current_page: currentPage,
        per_page: pageSize,
        totalPages: totalPages,
        from: from,
        to: to,
        startPage: currentPage,
        last_page: totalPages,
        pages: pages
      };
    }
  }
};
</script>
<style scoped>
.glyphicons::before {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// resources/js/sen-school/SenSchoolList.vue